module.exports = __webpack_public_path__ + "static/media/circus.e27c88e5.png";